module.exports = __webpack_public_path__ + "static/media/cred-card-pink.c8966654.svg";